import { useState } from 'react';
import { IconButton, Popover, Typography, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';
import { advisoriesLearnMoreLink } from 'constants/externalLinks';
import { logEvent } from 'actions/firebase';
import { DATA_LEARN_MORE } from 'constants/firebase';

const styles = {
	main: {
		height: 'fit-content',
		width: 'fit-content',
		padding: 20,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	},
	name: {
		fontWeight: 'bold',
		marginBottom: 20
	},
	button: {
		marginTop: 10,
		marginBottom: 10,
		textTransform: 'none',
		borderRadius: '20px'
	}
};
const AdvisoryInfoPopup = ({ advisory }) => {
	const { name } = advisory;
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const useStyles = makeStyles(styles);
	const classes = useStyles();
	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleLearnMore = () => {
		logEvent(DATA_LEARN_MORE);
		window.open(advisoriesLearnMoreLink);
		handleClose();
	};

	return (
		<div>
			<IconButton variant='contained' color='primary' onClick={handleClick} size='large'>
				<InfoIcon />
			</IconButton>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
			>
				<div className={classes.main}>
					<Typography variant='h5' component='h5' className={classes.name}>
						{name}
					</Typography>
					<Typography variant='subtitle1'>
						Questions about this type of advisory & how it applies to UAS?
					</Typography>
					<Button
						variant='outlined'
						className={classes.button}
						color='primary'
						onClick={handleLearnMore}
					>
						Learn More
					</Button>
				</div>
			</Popover>
		</div>
	);
};

export default AdvisoryInfoPopup;
